<div fxLayout="column" class="list-container">
  <ng-container *ngIf="handsetService.isHandset">
    <mat-divider></mat-divider>
  </ng-container>
  <mat-list class="nav" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="noshrink" style="padding-top: 0;">
    <ng-container *ngIf="isAdmin$ | async">
      <div>
        <div fxLayout="column" fxLayoutAlign="start stretch">
          <button *ngIf="!menuToggle" mat-button (click)="menuToggle = !menuToggle" class="centered-button-label">
            <app-icon name="account_circle" matListIcon></app-icon>
            Admin
          </button>

          <button *ngIf="menuToggle" mat-button (click)="menuToggle = !menuToggle" class="centered-button-label">
            <app-icon name="arrow_back" matListIcon></app-icon>
            Powrót
          </button>
        </div>
      </div>
      <mat-divider class="separator"></mat-divider>
    </ng-container>

    <ng-container *ngIf="!menuToggle">
      <div *ngFor="let item of sideNavItems.value">
        <div *ngIf="item.showItem" fxLayout="column" fxLayoutAlign="start stretch">
          <button mat-button routerLink="{{ item.link }}" routerLinkActive="active" (click)="close()">
            <div fxLayout="row" fxLayoutAlign="start center">
              <app-icon [name]="item.icon" matListIcon></app-icon>
              <div class="flex-1">{{ item.label }}</div>
              <ng-container *ngIf="item.showNotification && notificationsCountInfo | async as model">
                <div
                  class="alert-badge"
                  fxLayout="row"
                  fxLayoutAlign="center center"
                  *ngIf="!contentDataStoreService.hidden && model.customerBillerNotificationsCount"
                  [matTooltip]="'Dostawcy wymagający uwagi: ' + model.customerBillerNotificationsCount">
                  <app-icon name="error_filled"></app-icon>
                </div>
              </ng-container>
              <ng-container *ngIf=" item.showOffersBadge && notificationsCountInfo | async as model">
                <div class="badge"
                     *ngIf="model.notSeenOffersCount"
                     [matTooltip]="'Nowe oferty dostępne: ' + model.notSeenOffersCount">
                  {{ model.notSeenOffersCount }}
                </div>
              </ng-container>

              <ng-container *ngIf=" item.showNotificationDeferments && notificationsCountInfo | async as model">
                <div class="alert-badge"
                     fxLayout="row"
                     fxLayoutAlign="center center"
                     *ngIf="model.overdueDeferments"
                     [matTooltip]="'Liczba zaległości: ' + model.overdueDeferments">
                  <app-icon name="error_filled"></app-icon>
                </div>
              </ng-container>

            </div>
          </button>
        </div>
        <mat-divider *ngIf="item.showDividerAfter" class="separator"></mat-divider>
      </div>

      <ng-container *ngIf="appConfig.config.features.showUnusedSubpages && accountConfiguration | async as model">
        <div
          *ngIf="handsetService.isHandset && !model.hidden"
          class="config-progress-menu-item"
          fxLayout="column"
          fxLayoutAlign="start stretch">
          <button mat-button routerLink="/dashboard" routerLinkActive="active">
            <div fxLayout="row" fxLayoutAlign="start center">
              <app-icon name="speed" class="referral-icon" matListIcon></app-icon>
              <span class="flex-1">Konfiguracja: {{ model.scoreSum }}%</span>
            </div>
          </button>
        </div>
      </ng-container>

      <div *ngIf="appConfig.config.features.memberGetMemberEnabled &&
          appConfig.config.referral.active && handsetService.isHandset"
           class="referral-menu-item"
           fxLayout="column"
           fxLayoutAlign="start stretch">
        <button
          mat-button
          [routerLink]="appConfig.config.visaContest?.enabled ? '/rachunkisieplaca' : '/promotion-coupons'"
          routerLinkActive="active">
          <div class="flex items-center">
            <app-icon
              [name]="appConfig.config.visaContest?.enabled ? 'emoji_events' : 'redeem'"
              class="referral-icon"
              matListIcon>
            </app-icon>
            <span class="flex-1">{{ promotionCouponsService.statusMessage$ | async }}</span>
          </div>
        </button>
      </div>

    </ng-container>

    <ng-container *ngIf="menuToggle">
      <ng-container *ngIf="authStoreService.isAdmin">
        <h3 mat-subheader>Admin</h3>
        <div>
          <div fxLayout="column" fxLayoutAlign="start stretch">
            <button mat-button class="centered-button-label" routerLink="/admin/addLiability" routerLinkActive="active">
              <app-icon name="add" matListIcon></app-icon>
              Nowa faktura klienta
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/offers" routerLinkActive="active">
              <app-icon name="local_offer" matListIcon></app-icon>
              Oferty
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/config" routerLinkActive="active">
              <app-icon name="build" matListIcon></app-icon>
              Konfiguracja
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/deleteCustomer" routerLinkActive="active">
              <app-icon name="delete_forever" matListIcon></app-icon>
              Usuwanie konta
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/billerVerification" routerLinkActive="active">
              <app-icon name="check_circle" matListIcon></app-icon>
              Weryfikacja numerów konta
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/logs" routerLinkActive="active">
              <app-icon name="warning" matListIcon></app-icon>
              Logi
            </button>
            <button mat-button class="centered-button-label" routerLink="/admin/messages" routerLinkActive="active">
              <app-icon name="message_24px" matListIcon></app-icon>
              Wiadomości
            </button>
            <button mat-button class="centered-button-label" routerLink="/admin/payments" routerLinkActive="active">
              <app-icon name="payment" matListIcon></app-icon>
              Płatności
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/refund" routerLinkActive="active">
              <app-icon name="keyboard_backspace" matListIcon></app-icon>
              Zwroty
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/couponConfig" routerLinkActive="active">
              <app-icon name="local_offer" matListIcon></app-icon>
              Konfiguracja kuponów
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/generatePromotionCode" routerLinkActive="active">
              <app-icon name="social" matListIcon></app-icon>
              Generowanie kodów
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/impersonation" routerLinkActive="active">
              <app-icon name="supervisor_account" matListIcon></app-icon>
              Impersonacja użytkownika
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/xsell" routerLinkActive="active">
              <app-icon name="local_atm" matListIcon></app-icon>
              Oferty xsell
            </button>
            <button mat-button class="centered-button-label" routerLink="/admin/campaigns" routerLinkActive="active">
              <app-icon name="extension" matListIcon></app-icon>
              Kampanie promocyjne
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/blockCustomer" routerLinkActive="active">
              <app-icon name="block" matListIcon></app-icon>
              Blokowanie użytkownika
            </button>

            <button
              *ngIf="appConfig.config.analytics.intercom.enabled"
              mat-button
              routerLink="/admin/intercom"
              routerLinkActive="active">
              <app-icon name="assignment_ind" matListIcon></app-icon>
              Intercom
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/updateMarketingConsent" routerLinkActive="active">
              <app-icon name="unpublished" matListIcon></app-icon>
              Zgody marketingowe
            </button>

            <button mat-button class="centered-button-label" routerLink="/admin/personal-data" routerLinkActive="active">
              <app-icon name="perm_identity" matListIcon></app-icon>
              Dane Personalne
            </button>
          </div>
        </div>
        <mat-divider class="separator"></mat-divider>
      </ng-container>
    </ng-container>
    <div fxFlex>
    </div>
  </mat-list>
</div>
